import { Snackbar } from "@mui/material";
import { useNotificationContext } from "../contexts/NotificationContext";

export const GlobalNotificationSnackbar = () => {
  const { notification, onCloseNotification } = useNotificationContext();

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={notification !== undefined}
      autoHideDuration={notification?.autoHideDuration}
      onClose={onCloseNotification}
      message={notification?.text}
    />
  );
};

export default GlobalNotificationSnackbar;
